export default "__VITE_ASSET__DuAohUE1__"